import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const ScheduledTransactionService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}/scheduled-transaction`;

  const getScheduledTransactionsBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/search${queryString}`, {
      headers,
    });
  };

  const getCSSchedulePaymentsBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/cartingservicescheduledpayments/search${queryString}`, {
      headers,
    });
  };

  const getScheduledTransactionDetail = (id) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(`${BASE_URL}/${id}`, {
      headers,
    });
  };

  const getCSSPTransactionDetail = (id) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(`${BASE_URL}/cartingservicescheduledpayments/${id}`, {
      headers,
    });
  };

  const cancelScheduledTransaction = ({ scheduledTransactionId, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(
      `${BASE_URL}/${scheduledTransactionId}/cancel`,
      {
        headers,
      }
    );
  };

  const cancelCSScheduledTransaction = ({ scheduledTransactionId, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(
      `${BASE_URL}/cartingservicescheduledpayments/${scheduledTransactionId}/cancel`,
      {
        headers,
      }
    );
  };

  const processScheduledTransaction = ({ scheduledTransactionId, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/${scheduledTransactionId}/process`,
      undefined,
      {
        headers,
      }
    );
  };

  const processCSScheduledTransaction = ({ scheduledTransactionId, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/cartingservicescheduledpayments/${scheduledTransactionId}/process`,
      undefined,
      {
        headers,
      }
    );
  };

  service.getScheduledTransactionsBySearchCriteria = getScheduledTransactionsBySearchCriteria;
  service.getScheduledTransactionDetail = getScheduledTransactionDetail;
  service.cancelScheduledTransaction = cancelScheduledTransaction;
  service.cancelCSScheduledTransaction = cancelCSScheduledTransaction;
  service.processScheduledTransaction = processScheduledTransaction;
  service.processCSScheduledTransaction = processCSScheduledTransaction;
  service.getCSSchedulePaymentsBySearchCriteria = getCSSchedulePaymentsBySearchCriteria;
  service.getCSSPTransactionDetail = getCSSPTransactionDetail;
  return service;
})();

export default ScheduledTransactionService;
